/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Zip/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Zip({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Addresses/AddressItem/Zip",
  isInvalid,
  onChange
  
}) {
let addressZipValueData = fromData.useDataValue({ viewPath,
context: 'address',
path: 'zip',
})
let addressZipIsValidData = fromData.useDataIsValid({ viewPath,
context: 'address',
path: 'zip',
validate: fromValidate.zip,
})
let addressZipChangeData = fromData.useDataChange({ viewPath,
context: 'address',
path: 'zip',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="address.zip"
 validate="/Data/validate.js zip"
 invalid={!addressZipIsValidData}
 value={addressZipValueData}
 onChange={addressZipChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="ZIP Code"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}